import moment from "moment";
import { mainnet, sepolia } from "wagmi";
import { bsc, bscTestnet } from "wagmi/chains";

export const trimAddress = (addr) => {
  return `${addr.substring(0, 6)}...${addr.substring(addr.length - 4)}`;
}


export const formatDate = (unixTime) => {
  try {
    let dateString = moment(unixTime).format('lll');
    return dateString;
  }
  catch (err) {
    console.log(err.message);
  }
}


export const blockstar_test = {
  id: 55,
  name: 'BlockStar TEST',
  network: 'blockstar-test',
  nativeCurrency: {
    decimals: 18,
    name: 'BlockStar',
    symbol: 'TBST',
  },
  rpcUrls: {
    public: { http: ['https://testnet-rpc.blockstar.one'] },
    default: { http: ['https://testnet-rpc.blockstar.one'] },
  },
  blockExplorers: {
    etherscan: { name: 'BlockStarScan', url: 'https://testnet-scan.blockstar.one' },
    default: { name: 'BlockStarScan', url: 'https://testnet-scan.blockstar.one' },
  },
  contracts: {
    multicall3: {
      address: '0xBF429308D450182B13afB96413ffc6855c3388C9',
      blockCreated: 12230,
    },
  },
}


export const blockstar = {
  id: 5512,
  name: 'BlockStar',
  network: 'blockstar',
  nativeCurrency: {
    decimals: 18,
    name: 'BlockStar',
    symbol: 'BST',
  },
  rpcUrls: {
    public: { http: ['https://mainnet-rpc.blockstar.one'] },
    default: { http: ['https://mainnet-rpc.blockstar.one'] },
  },
  blockExplorers: {
    etherscan: { name: 'BlockStarScan', url: 'https://scan.blockstar.one' },
    default: { name: 'BlockStarScan', url: 'https://scan.blockstar.one' },
  },
  contracts: {
    multicall3: {
      address: '0x3c9d85F5C95E40C52980a8648397ca6E7cfA7932',
      blockCreated: 12230,
    },
  }
}

export const contract = {
  // 55: {
  //   MULTICALL_ADDRESS: "0xBF429308D450182B13afB96413ffc6855c3388C9",
  //   DAO_ADDRESS: "0x3328E5FE9945339a64d5eACDD1ce1E1586c5E6EF",
  //   NFT_ADDRESS: [
  //     "0xc70B3104024287B8226711E7b29E5A0fd036f5A3"
  //   ]
  // },
  5512: {
    MULTICALL_ADDRESS: "0x3c9d85F5C95E40C52980a8648397ca6E7cfA7932",
    DAO_ADDRESS: "0xBc62F954Cb7cC1e0Ef786B81f87E4f9886aab2Ce",
    NFT_ADDRESS: [
      "0x7d755f6a42323bf0791eE8658e6770A8C03f3680",
      "0x88a8bFFAC71557C9A646e212Af8D6670696E6DD1",
      "0x65328711d28f5eB259590fB58d86B0E299bd8BEd",
    ]
  }
}

export const DEFAULT_CHAIN = 5512;
export const IPFS_URL = 'https://alchemy.mypinata.cloud/ipfs/';
export const chains = [blockstar , bsc , sepolia]

export const DAO_SUPPOTED_CHAIN = [56,11155111]
export const DAO_DEFAULT_CHAIN = 56;

export const DAO_REWARD = {
  // 55: {
  //   DAO_REWARD_ADDRESS: "0x5670eC8136bA556b430A275d4DEcDb46AC04e835",
  //   MULTICALL_ADDRESS :  "0xBF429308D450182B13afB96413ffc6855c3388C9",
  //   RPC_URL : "https://testnet-rpc.blockstar.one",
  //   symbol : "BST"
  // },
  5512: {
    DAO_REWARD_ADDRESS: "0x7C22eD8726e5F264c587DB5DD42fD7123713c47b",
    MULTICALL_ADDRESS :  "0x3c9d85F5C95E40C52980a8648397ca6E7cfA7932",
    RPC_URL : "https://mainnet-rpc.blockstar.one",
    symbol : "BST"
  },
  // 97 : {
  //   DAO_REWARD_ADDRESS: "0x5a062d6fdbb7fc4ba52fadd658a5a1cce39257ad",
  //   MULTICALL_ADDRESS :  "0xa54fE4a3DbD1Eb21524Cd73754666b7E13b4cB18",
  //   RPC_URL : "https://data-seed-prebsc-2-s2.bnbchain.org:8545",
  //   symbol : "BNB"
  // },
  56 : {
    DAO_REWARD_ADDRESS: "0x0368Ca8547b2Fc95c6EAc99767ec70fa36457147",
    MULTICALL_ADDRESS :  "0xcf591ce5574258ac4550d96c545e4f3fd49a74ec",
    RPC_URL : "https://bsc-dataseed2.bnbchain.org",
    symbol : "BNB"
  },
  11155111 : {
    DAO_REWARD_ADDRESS: "0xbc34e182cba4afa2cb4bea393d0430264419283c",
    MULTICALL_ADDRESS :  "0xBEe33b6B1C3df2c4468510E87d6330daA5709F3E",
    RPC_URL : "https://endpoints.omniatech.io/v1/eth/sepolia/public",
    symbol : "ETH"
  }
}
